import React from "react";

export const AmountValidation = (amount) => {
  const strAmount = String(amount); // Ensure amount is treated as a string
  const numericAmount = Number(amount);

  if (
    isNaN(amount) || // Check if amount is NaN
    // amount === "" || // Check if amount is empty
    // amount.endsWith(".") || // Check if amount ends with a dot
    strAmount === "" || // Check if amount is empty
    strAmount.endsWith(".") || // Check if amount ends with a dot
    numericAmount === 0 || // Check if amount is exactly zero
    numericAmount < 1 || // Check if amount is less than 1
    numericAmount <= 0 // Check if amount is less than or equal to zero

    //!/^[1-9]\d*$/.test(amount) // Check if amount doesn't start with a non-zero digit
  ) {
    return true;
  }

  return false;
};
export const AmountValidationFloat = (amount) => {
  const strAmount = String(amount); // Ensure amount is treated as a string
  const numericAmount = parseFloat(amount); // Parse the amount as a float

  if (
    isNaN(numericAmount) || // Check if amount is NaN
    strAmount === "" || // Check if amount is empty
    strAmount.endsWith(".") || // Check if amount ends with a dot
    numericAmount <= 0 // Check if amount is less than or equal to zero
  ) {
    return true;
  }

  return false;
};
const commonValidation = () => {
  return <div>commonValidation</div>;
};

export default commonValidation;
